import { render } from "./skeleton.vue?vue&type=template&id=622fbe5e&scoped=true"
import script from "./skeleton.vue?vue&type=script&lang=js"
export * from "./skeleton.vue?vue&type=script&lang=js"

import "./skeleton.vue?vue&type=style&index=0&id=622fbe5e&scoped=true&lang=css"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622fbe5e"]])

export default __exports__